import { render, staticRenderFns } from "./RequestEditTabBiddersValidation.vue?vue&type=template&id=bafb7370&scoped=true&"
import script from "./RequestEditTabBiddersValidation.vue?vue&type=script&lang=js&"
export * from "./RequestEditTabBiddersValidation.vue?vue&type=script&lang=js&"
import style0 from "./RequestEditTabBiddersValidation.vue?vue&type=style&index=0&id=bafb7370&lang=scss&scoped=true&"
import style1 from "./RequestEditTabBiddersValidation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafb7370",
  null
  
)

export default component.exports